import { render, staticRenderFns } from "./UnscheduledModelListSideMenu.vue?vue&type=template&id=38f9bd48&scoped=true"
import script from "./UnscheduledModelListSideMenu.vue?vue&type=script&lang=js"
export * from "./UnscheduledModelListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./UnscheduledModelListSideMenu.vue?vue&type=style&index=0&id=38f9bd48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9bd48",
  null
  
)

export default component.exports